import { Component, OnInit } from "@angular/core";


@Component({
  selector: 'app-loading-progress-bar',
  templateUrl: './loading-progress-bar.component.html',
  styleUrls: ['./loading-progress-bar.component.css'],
})
export class LoadingProgressBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
